import { create } from 'zustand';
import { Agent } from '../types/agent';
import { getRandomAgent } from '../data/agents';

interface AgentState {
  currentAgent: Agent;
  setCurrentAgent: (agent: Agent) => void;
  selectRandomAgent: () => void;
}

export const useAgentStore = create<AgentState>((set) => ({
  currentAgent: getRandomAgent(),
  setCurrentAgent: (agent) => set({ currentAgent: agent }),
  selectRandomAgent: () => set({ currentAgent: getRandomAgent() })
}));